module.exports = __webpack_public_path__ + "static/media/Eventxtra Virtual Platform_v8-13.020eadfd.png";